// A view filtered by exactly one assignee shows that person's avatar instead of
// its icon. Returns null for zero or multiple assignees.
export function soleAssigneeId(view: { filters: unknown }): string | null {
	const ids = (
		(view.filters as { assigneeIds?: (string | null)[] } | null | undefined)
			?.assigneeIds ?? []
	).filter((id): id is string => !!id)
	return ids.length === 1 ? ids[0]! : null
}
